export default __webpack_public_path__ + "static/media/math_instructions.41c544f7.pdf";